import { ClassSwiperPeople } from "./modules/ClassSwiperPeople.js";
import { ClassMotionCss } from "./modules/ClassMotionCss.js";

document.addEventListener("DOMContentLoaded", function () {
  const motionCss = new ClassMotionCss();

  /* ========== Cookie ========== */

  if (location.search.includes("resetIntro")) {
    document.cookie = "intro=; Max-Age=0; path=/";
    localStorage.removeItem("intro");
  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  //?resetIntro=1
  const introCookie = getCookie("intro");
  if (introCookie === "") {
    //openingあり
    console.log("openingあり");

    setTimeout(function () {
      setTimeout(function () {
        document.body.classList.add("opening-animation-01");
      }, 100);

      setTimeout(function () {
        document.body.classList.add("opening-animation-02");
      }, 1800);

      setTimeout(function () {
        motionCss.excute();
      }, 1500);

      setTimeout(function () {
        document.body.classList.add("opening-animation-03");
      }, 2100);
    }, 500);

    setCookie("intro", "visited", 7);
  } else {
    //openingなし
    document.body.classList.add("opening-animation-none-pre");
    setTimeout(function () {
      document.body.classList.add("opening-animation-none");
      motionCss.excute();
    }, 1);

    console.log("openingなしopeningなし");
  }

  /* ========== swiper ========== */
  const swiperPeopleElem = document.querySelector("#js-swiper-people");
  if (swiperPeopleElem) {
    const swiperPeople = new ClassSwiperPeople(swiperPeopleElem);
    setTimeout(function () {
      swiperPeople.play();
    }, 500);
  }
});
